import { userCan } from '../../../api/helper';

class UserAcl {
  constructor(name) {
    this.name = name;
  }

  hasAccess = () => {
    return userCan( this.name );
  }
}

export const ACL = {
  ADMIN: {
    USERS: {
      CREATE: new UserAcl( 'admin-create-users' ),
      VIEW: new UserAcl( 'admin-read-users' ),
      EDIT: new UserAcl( 'admin-update-users' ),
      DELETE: new UserAcl( 'admin-delete-users' ),
      LIST: new UserAcl( 'admin-list-users' ),
      SEARCH: new UserAcl( 'admin-search-users' ),
    },
    GROUPS: {
      CREATE: new UserAcl( 'admin-create-groups' ),
      VIEW: new UserAcl( 'admin-read-groups' ),
      EDIT: new UserAcl( 'admin-update-groups' ),
      DELETE: new UserAcl( 'admin-delete-groups' ),
      LIST: new UserAcl( 'admin-list-groups' ),
      SEARCH: new UserAcl( 'admin-search-groups' ),
      SYNC_USERS: new UserAcl( 'admin-sync-group-users' ),
      SYNC_ACLS: new UserAcl( 'admin-sync-group-acls' ),
      LIST_ACLS: new UserAcl( 'admin-list-acls' ),
    }
  },
  CLIENT: {
    ORGANIZATIONS: {
      EXPORT: new UserAcl( 'export-organizations' ),
    },
    USERS: {
      VIEW: new UserAcl( 'client-read-users' ),
      EDIT: new UserAcl( 'client-update-users' ),
      DELETE: new UserAcl( 'client-delete-users' ),
      LIST: new UserAcl( 'client-list-users' ),
      SEARCH: new UserAcl( 'client-search-users' ),
      LOCK: new UserAcl( 'client-lock-users' ),
      RESET_PASSWORD: new UserAcl( 'client-reset-password' ),
    },
    ORDERS: {
      CREATE: new UserAcl( 'client-create-orders' ),
      VIEW: new UserAcl( 'client-read-orders' ),
      EDIT: new UserAcl( 'client-update-orders' ),
      DELETE: new UserAcl( 'client-delete-orders' ),
      LIST: new UserAcl( 'client-list-orders' ),
      SEARCH: new UserAcl( 'client-search-orders' ),
      CANCEL: new UserAcl( 'client-cancel-orders' ),
      SEND_EMAIL: new UserAcl( 'client-send-email-invoice' ),
    },
    DOCUMENTS: {
      LIST: new UserAcl( 'client-list-documents' ),
      SEARCH: new UserAcl( 'client-search-documents' ),
      VIEW: new UserAcl( 'client-read-documents' ),
    },
    REPORTS: {
      LIST: new UserAcl('admin-list-reports' ),
    },
    TICKETS: {
      MANAGE: new UserAcl('client-manage-tickets'),
    },
    CAMPAIGNS: {
      CREATE: new UserAcl( 'client-create-campaigns' ),
      VIEW: new UserAcl( 'client-read-campaigns' ),
      EDIT: new UserAcl( 'client-update-campaigns' ),
      DELETE: new UserAcl( 'client-delete-campaigns' ),
      LIST: new UserAcl( 'client-list-campaigns' ),
      SEARCH: new UserAcl( 'client-search-campaigns' ),
    },
    COUPONS: {
      CREATE: new UserAcl( 'client-create-coupons' ),
      VIEW: new UserAcl( 'client-read-coupons' ),
      EDIT: new UserAcl( 'client-update-coupons' ),
      DELETE: new UserAcl( 'client-delete-coupons' ),
      LIST: new UserAcl( 'client-list-coupons' ),
      SEARCH: new UserAcl( 'client-search-coupons' ),
    },
  }
}
